import React from 'react';

interface StatsCardProps {
  value: number;
  label: string;
  icon: React.ReactNode;
  iconBgColor: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  value,
  label,
  icon,
  iconBgColor,
}) => (
  <div className="bg-white rounded-xl border border-gray-200 p-2">
    <div className="flex items-center gap-3">
      <div
        className={`w-10 h-10 rounded-lg flex items-center justify-center ${iconBgColor}`}
      >
        {icon}
      </div>
      <div>
        <p className="text-2xl font-semibold text-gray-900">{value}</p>
        <p className="text-sm text-gray-500">{label}</p>
      </div>
    </div>
  </div>
);
